import { useContext, useEffect, useRef, useState } from "react";
import { Calendar, ChevronsRight, MessageSquare, Search, Trello } from "react-feather";
import { BsBarChartLine, BsPeopleFill, BsPieChartFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import QueueStatus from "../../../components/Dashboards/QueueStatus";
import { EnquiryGridSelectionContext } from "../../../contexts/enquiry-grid-selection.context";
import { getPreference, iPreference, savePrefence } from "../../../interfaces/preference";
import { adjustHamburgerMenu } from "../../../Logic/BurgerMenu";
import { LoadActiveMyEnquiries, LoadMailbox, LoadSearchResults } from "../../../Logic/Enquiries/Load";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import { setShowEnquiry, setShowWizard } from "../../../state/restrictedViewSlice";
import {
    setCalendarVisibility,
    setEnquiriesVisibility,
    setMISReportsVisibility,
    setQueuesVisibility,
    setReportsVisibility,
    setSearchResultsVisibility,
    setTeamCalendarVisibility,
    setTeamEnquiriesVisibility,
} from "../../../state/siteSlice";
import { RootState, useAppDispatch } from "../../../state/store";
import { addTab, removeFirstTab, removeTab, setTabVisibility, switchFirstTab } from "../../../state/tabRow";
import { resetSort } from "../../../utilities/sort";
import "./sidebar.scss";

function Sidebar(props: any) {
    const [expanded, setExpanded] = useState(false);
    const SiteInformation = useSelector((state: RootState) => state.SiteInformation);
    const permissions = useSelector((state: RootState) => state.permissions);
    const { selectionProperties, SetEnquiryGridSelectionProperties } = useContext(EnquiryGridSelectionContext);
    const dispatch = useAppDispatch();
    const expandTag = useRef<HTMLDivElement>(null);

    useEffect(() => {
        adjustHamburgerMenu(expanded);
        let preference: iPreference = getPreference();
        setExpanded(preference.interface.SideBarExpanded);
    }, []);

    useEffect(() => {
        if (SiteInformation.teamEnquiriesVisible == false && SiteInformation.teamCalendarVisible == false) {
            dispatch(removeTab(1001));
            dispatch(removeTab(1002));
        }
    }, [SiteInformation]);

    useEffect(() => {
        window.addEventListener("resize", checkWinWidth);
        return () => window.removeEventListener("resize", checkWinWidth);
    }, []);

    function checkWinWidth() {
        if (window.innerWidth < 820) {
            setExpanded(false);
            expandTag.current!.style.visibility = "hidden";
        } else {
            let preference: iPreference = getPreference();
            expandTag.current!.style.visibility = "visible";
            setExpanded(preference.interface.SideBarExpanded);
        }
    }

    async function showMyTeamEnquiries() {
        if (SiteInformation.teamEnquiriesVisible) {
            return;
        }

        const lastTouched = getLastTouched();
        lastTouched.lastActiveListType = lastTouched.MyTeams.ActiveList;
        saveLastTouched(lastTouched);
        SetEnquiryGridSelectionProperties({ multiSelect: false, selectedEnquiries: [] });
        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));

        if (permissions.AnyMailbox.ManageTeamEnquiries == true) {
            dispatch(
                addTab({
                    active: true,
                    enquiryId: undefined,
                    label: "Team Enquiries",
                    key: 1001,
                    onclick: () => {
                        dispatch(setTabVisibility(1001));
                        dispatch(setTeamEnquiriesVisibility());
                    },
                }),
            );
        }
        if (permissions.Tenant.ViewCalendarForUser == true) {
            dispatch(
                addTab({
                    active: true,
                    enquiryId: undefined,
                    label: "Team Calenders",
                    key: 1002,
                    onclick: () => {
                        dispatch(setTabVisibility(1002));
                        dispatch(setTeamCalendarVisibility());
                    },
                }),
            );
        }
        //dispatch(addTab({ active: true, enquiryId: 2, label: "Calender", key: 1002 }));
        dispatch(removeFirstTab());

        dispatch(setTabVisibility(1001));
        dispatch(setTeamEnquiriesVisibility());
    }

    async function showSearchResults() {
        if (SiteInformation.searchResultsVisible) {
            return;
        }

        const lastTouched = getLastTouched();
        lastTouched.lastActiveListType = "Results";
        saveLastTouched(lastTouched);

        SetEnquiryGridSelectionProperties({ multiSelect: false, selectedEnquiries: [] });
        await LoadSearchResults();

        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));
        dispatch(switchFirstTab("Search Results"));
        dispatch(removeTab(1001));
        dispatch(setSearchResultsVisibility());
    }

    async function showQLists() {
        if (SiteInformation.queuesListVisible) {
            return;
        }

        const lastTouched = getLastTouched();
        const mailbox = lastTouched.Queue.ActiveList;
        lastTouched.lastActiveListType = mailbox.toString();
        saveLastTouched(lastTouched);

        SetEnquiryGridSelectionProperties({ multiSelect: false, selectedEnquiries: [] });
        resetSort();
        await LoadMailbox(mailbox);

        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));
        dispatch(switchFirstTab("Mailboxes"));
        dispatch(setQueuesVisibility());
        dispatch(removeTab(1001));
    }
    async function showMyEnquiryLists() {
        if (SiteInformation.enquiriesListVisible) {
            return;
        }

        const lastTouched = getLastTouched();
        lastTouched.lastActiveListType = lastTouched.MyEnquiries.ActiveList;
        saveLastTouched(lastTouched);

        SetEnquiryGridSelectionProperties({ multiSelect: false, selectedEnquiries: [] });
        resetSort();
        await LoadActiveMyEnquiries();

        dispatch(setShowEnquiry(false));
        dispatch(setShowWizard(false));
        dispatch(switchFirstTab("My Enquiries"));
        dispatch(setEnquiriesVisibility());
        dispatch(removeTab(1001));
    }

    function toggleSideNav() {
        setExpanded(current => !current);
        let preference: iPreference = getPreference();
        preference.interface.SideBarExpanded = !expanded;
        savePrefence(preference);
    }

    return (
        <div className={"side-nav" + (expanded ? " expanded" : "")}>
            <div className="logo-row">
                <div className="logo-icon">
                    <div className="logo-bg"></div>
                </div>
                <div className="logo-label text-line-1 label">&nbsp;</div>
                <div className="nav-btns">
                    {/*<X className='nav-btn collapse-nav' onClick={collapseSideNav} />
                    <BarChart2 className='nav-btn expand-nav' onClick={expandSideNav} />*/}
                </div>
            </div>
            <div className="side-nav--links--toplink">
                {permissions.Tenant.ViewMyEnquiries && (
                    <div
                        className={
                            SiteInformation.enquiriesListVisible
                                ? "side-nav--links--link active"
                                : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--my-enquiries"
                            onClick={showMyEnquiryLists}
                            title="My Enquiries"
                        >
                            <div className="side-nav--links--link--icon">
                                <MessageSquare className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label"> My Enquiries</div>
                        </div>
                    </div>
                )}
                {permissions.Tenant.ViewCalendar && (
                    <div
                        className={
                            SiteInformation.calendarVisible ? "side-nav--links--link active" : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--my-calendar"
                            onClick={() => dispatch(setCalendarVisibility())}
                            title="My Calendar"
                        >
                            <div className="side-nav--links--link--icon">
                                <Calendar className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label"> My Calendar</div>
                        </div>
                    </div>
                )}
                {(permissions.AnyMailbox.ManageTeamEnquiries == true ||
                    permissions.Tenant.ViewCalendarForUser == true) && (
                    <div
                        className={
                            SiteInformation.teamEnquiriesVisible
                                ? "side-nav--links--link active"
                                : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--mailboxes"
                            onClick={showMyTeamEnquiries}
                            title="My Teams"
                        >
                            <div className="side-nav--links--link--icon">
                                <BsPeopleFill className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label">My Team</div>
                        </div>
                    </div>
                )}

                {permissions.Tenant.Search && (
                    <div
                        className={
                            SiteInformation.searchResultsVisible
                                ? "side-nav--links--link active"
                                : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--searchResults"
                            onClick={showSearchResults}
                            title="Search Results"
                        >
                            <div className="side-nav--links--link--icon">
                                <Search className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label">Search Results</div>
                        </div>
                    </div>
                )}
                {permissions.AnyMailbox.ViewEnquiryList && (
                    <div
                        className={
                            SiteInformation.queuesListVisible ? "side-nav--links--link active" : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--mailboxes"
                            onClick={showQLists}
                            title="Mailboxes"
                        >
                            <div className="side-nav--links--link--icon">
                                <Trello className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label">Mailboxes</div>
                        </div>
                    </div>
                )}
                {permissions.AnyMailbox.ViewReports && (
                    <div
                        className={
                            SiteInformation.reportsVisible ? "side-nav--links--link active" : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--Reports"
                            onClick={() => {
                                dispatch(setReportsVisibility());
                            }}
                            title="Reports"
                        >
                            <div className="side-nav--links--link--icon">
                                <BsBarChartLine className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label">Reports</div>
                        </div>
                    </div>
                )}

                {permissions.Tenant.ElevatedReports == true && (
                    <div
                        className={
                            SiteInformation.MISreportsVisible ? "side-nav--links--link active" : "side-nav--links--link"
                        }
                    >
                        <div
                            className="side-nav--links--link-wrap"
                            id="side-nav-link--Extracts"
                            onClick={() => {
                                dispatch(setMISReportsVisibility());
                            }}
                            title="MIS Data Extract"
                        >
                            <div className="side-nav--links--link--icon">
                                <BsPieChartFill className="nav-icon" />
                            </div>
                            <div className="side-nav--links--link--label text-line-1 label">Data Extracts</div>
                        </div>
                    </div>
                )}
            </div>
            <div
                style={{
                    height: "calc(100%)",
                    padding: "00px 10px 0px 10px",
                    overflow: "hidden",
                    marginTop: "-10px",
                    marginBottom: "-20px",
                }}
            >
                {expanded &&
                    (SiteInformation.queuesListVisible ||
                        SiteInformation.enquiriesListVisible ||
                        SiteInformation.teamEnquiriesVisible) && <QueueStatus></QueueStatus>}
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                <div
                    className="ExpandContractRow"
                    onClick={toggleSideNav}
                    title={expanded ? "Close Menu" : "Expand Menu"}
                    ref={expandTag}
                >
                    {" "}
                    <ChevronsRight className="ExpandIcon"></ChevronsRight>
                </div>
                <div
                    className="EMSLogo"
                    title="Kunye Cloud Application 2025 "
                >
                    {" "}
                    &nbsp; {expanded && <div className="EMS-Version">{process.env.REACT_APP_VERSION}</div>}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
